import { gql } from '@apollo/client';

export const GetSchoolTypesQuery = gql`
    query GetSchoolTypes($locationId: ID!) {
        getSchoolTypes(locationId: $locationId)
    }
`;
